import { useEffect, useRef, useState } from 'react';
import styles from '../buildCard.module.sass';
import { Button } from 'react-bootstrap';
import parse from 'html-react-parser';

interface ReadMoreProps {
    text: string;
    expanded: boolean;
}

export const RenderBasedOnHeight = (props: ReadMoreProps) => {

    const [isCollapsed, setIsCollapsed] = useState(!props.expanded);
    const [expandedHeight, setExpandedHeight] = useState<number>();
    const [collapsedHeight, setCollapsedHeight] = useState<number>();
    const boxRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            const height = boxRef.current.getBoundingClientRect().height;
            setExpandedHeight(height);
            setCollapsedHeight(60);
        }, 0);
    }, []);

    const renderedHeight = isCollapsed ? `${collapsedHeight}px` : `${expandedHeight}px`;
    return (
        <div className={styles.cardContent}>
            <div style={{ height: renderedHeight, overflow: 'hidden', maxWidth: 'calc(100% - 25px)' }} ref={boxRef}>
                {parse(props.text)}
            </div>
            {expandedHeight > collapsedHeight &&
                <Button
                    variant="link"
                    className={`${styles.collapseToggleButton} ${!isCollapsed && styles.expanded}`}
                    tabIndex={0}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    {isCollapsed ?
                        <i className="fas fa-chevron-down" /> :
                        <i className="fas fa-chevron-up" />
                    }
                </Button>
            }
        </div>
    );
};
